import { WebVitalsMetric } from './types';

const buffer: Array<WebVitalsMetric> = [];
let flushed = false;

export const reportWebVitals = (metric: WebVitalsMetric) => {
  /** We need to use the global window here because this is called by Nextjs directly, and we have no way to inject dependencies */
  const handleWebVitals = globalThis.window?.handleWebVitals;

  if (handleWebVitals) {
    if (!flushed) {
      handleWebVitals(buffer);
      flushed = true;
    }

    handleWebVitals([metric]);
  } else {
    buffer.push(metric);
  }
};
